export default __webpack_public_path__ + "static/media/pic7.266c68c5.jpg";